import React, {useEffect, useState} from 'react';
import _ from "lodash";
import AddEditDimension from "./add-edit-dimension";
import {searchDimensionsWithSearchCriteria} from "../../services/dimension-data.service";
import DimensionFilters from "./dimension-filters";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {DIMENSION_FIELDS_LIST} from "../../constants/dimension.constant";
import GoToLink from "../../../common/ui/go-to-link";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";


const defaultFilterCriteria: any = {};

const DimensionsList = () => {
    const [dimensionsList, setDimensionsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getDimensionList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const dimensionListResult = await searchDimensionsWithSearchCriteria(searchCriteriaList);

        setDimensionsList(dimensionListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getDimensionList();
    }, [filterCriteria]);

    const refreshDimensionList = async () => {
        await getDimensionList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Dimension
                    </div>

                    {/*<DimensionFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    <div className="ml-2">
                        <AddEditDimension
                            isAddDimension={true}
                            refreshDimensionList={refreshDimensionList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={dimensionsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Dimensions'}/>

                    {dimensionsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {DIMENSION_FIELDS_LIST?.map((dimensionField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${dimensionField?.cssClass}`}>{dimensionField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {dimensionsList?.map((dimension, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {DIMENSION_FIELDS_LIST?.map((dimensionField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${dimensionField?.cssClass}`}>
                                                {dimensionField?.optionsMap &&
                                                    <>{dimensionField?.optionsMap[dimension[dimensionField?.attribute]]?.name}</>
                                                }

                                                {!dimensionField?.optionsMap &&
                                                    <>
                                                        {!dimensionField?.isBoolean &&
                                                            <>
                                                                {dimension[dimensionField?.attribute]}
                                                            </>
                                                        }


                                                        {dimensionField?.isBoolean &&
                                                            <>

                                                                {dimension[dimensionField?.attribute] &&
                                                                    <>
                                                                        Yes
                                                                    </>
                                                                }

                                                                {!dimension[dimensionField?.attribute] &&
                                                                    <>
                                                                        No
                                                                    </>
                                                                }
                                                            </>
                                                        }

                                                        {dimensionField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {dimension[dimensionField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">
                                            <AddEditDimension
                                                isEditDimension={true}
                                                selectedDimension={dimension}
                                                refreshDimensionList={refreshDimensionList}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default DimensionsList
